import {NavItem, NavSection} from "~/components/header/collapsed-header/subnavigation/common";
import {useTranslation} from "react-i18next";

export function PersonalUseSubSection({ close}: {close: () => void}) {
    const { t } = useTranslation("common");

    return <NavSection value="personal-use" label={t("nav.personal_use")}>
        <NavItem label={t("subnav.personal_use.families.name")} to="/personal-use/families" onClick={close} />
        <NavItem label={t("subnav.personal_use.teen_drivers.name")} to="/personal-use/teen-drivers" onClick={close} />
        <NavItem label={t("subnav.personal_use.aging_parents")} to="/personal-use/senior-drivers" onClick={close} />
        <NavItem label={t("subnav.personal_use.tech_enthusiasts.name")} to="/personal-use/tech-enthusiasts" onClick={close} />
        <NavItem label={t("subnav.personal_use.all_solutions")} to="/personal-use" onClick={close} />
    </NavSection>
}
